import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        nav: PropTypes.any,
    }

    render() {
        return (
            <ParadigmaModal
                navButton={(this.props.nav ? true : false)}
                nav={this.props.nav}

                getUrl={api.proyectos.config.presupuesto.formula.edit}
                postUrl={api.proyectos.config.presupuesto.formula.edit}
                onSubmit={() => null}
                id={() => 1}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"La Fórmula ha sido editada con éxito."}
                title={"Editar Fórmula"}
                buttonTitle={"Editar Fórmula"}
                buttonIcon={"fa fa-pencil fa-lg"}

                saveButton={true}
                closeButton={true}
            >
                <ParadigmaLabeledInput type="textarea" fieldName="ecuacion" label="Fórmula" labelColumns={12} fieldColumns={12} />
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_Formula/Edit.js